<template>
  <ais-instant-search
      class="ais-search-container"
      :class="searchOpen ? 'active' : ''"
      :search-client="searchClient"
      :index-name="index_search"
      v-click-outside="closeSearch"
  >
    <div
        class="ais-search-container__cta-search"
        @click="searchOpen = !searchOpen"
    >
      <icon-search v-if="!searchOpen"/>
      <icon-close v-else/>
    </div>

    <ais-search-box>
      <algolia-debounced-search-box />
    </ais-search-box>
    <ais-stats>
      <div slot-scope="{ query }" v-show="query && searchOpen">
        <ais-hits class="ais-search-results row no-gutters">
          <div slot-scope="{ items }">
            <ais-state-results>
              <h3 slot-scope="{ state: { query }, results: { hits } }">
                {{
                  $t('generalUi.searchCount', {
                    count: hits.length,
                    query: query
                  })
                }}
              </h3>
            </ais-state-results>
            <div
                class="ais-search-results__item"
                v-for="item in items"
                :key="item.objectID"
            >
              <a class="text-dark" :href="item.url">
                <ais-highlight attribute="title" :hit="item"/>
              </a>
            </div>
          </div>
        </ais-hits>
      </div>
    </ais-stats>
  </ais-instant-search>
</template>

<script>
import algoliasearch from 'algoliasearch/lite'
import ClickOutside from 'vue-click-outside'
import IconSearch from '../icons/IconSearch.vue'
import IconClose from '../icons/IconClose.vue'
import AlgoliaDebouncedSearchBox from './AlgoliaDebouncedSearchBox.vue'
import { ALGOLIA } from '../../router/configSites'

const algoliaClient = algoliasearch(ALGOLIA.appId, ALGOLIA.apiKey)

const searchClient = {
  ...algoliaClient,
  search (requests) {
    if (requests.every(({ params }) => !params.query)) {
      return Promise.resolve({
        results: requests.map(() => ({
          hits: [],
          nbHits: 0,
          nbPages: 0,
          page: 0,
          processingTimeMS: 0
        }))
      })
    }

    return algoliaClient.search(requests)
  }
}

export default {
  components: {
    IconSearch,
    IconClose,
    AlgoliaDebouncedSearchBox
  },
  props: {
    siteID: {
      type: String,
      default: '4'
    },
    env: {
      type: String,

      default: ''
    }
  },
  data () {
    return {
      searchClient,
      searchOpen: false,
      index_search: ''
    }
  },
  created () {
    this.index_search = this.getSiteIndex()
  },
  methods: {
    getSiteIndex () {
      let searchIndex = 'bumpertobumper_'
      if (
        process.env.NODE_ENV === 'development' ||
          process.env.NODE_ENV === 'staging'
      ) {
        searchIndex = searchIndex.concat('staging_')
      }
      searchIndex = searchIndex.concat(
        String(this.siteID),
        '_',
        this.$i18n.locale.toLowerCase()
      )
      return searchIndex
    },
    closeSearch () {
      if (this.searchOpen) {
        this.searchOpen = !this.searchOpen
      }
    }
  },
  directives: {
    ClickOutside
  }
}
</script>

<style lang="scss">
.ais-search-container {
  width: 6.3333333333vw;

  .ais-Stats-text {
    display: none;
  }

  .ais-search-input {
    position: absolute;
    top: 100%;
    right: 0;
    width: 0vw;
    height: 70px;
    border: none;
    border-radius: 0;
    transition: all 0.2s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    pointer-events: none;
    padding: 0;

    @include breakpoint('lg') {
      bottom: 0;
      top: initial;
    }

    /* clears the 'X' from Internet Explorer */
    &::-ms-clear,
    &::-ms-reveal {
      display: none;
      width: 0;
      height: 0;
    }

    /* clears the 'X' from Chrome */
    &::-webkit-search-decoration,
    &::-webkit-search-cancel-button,
    &::-webkit-search-results-button,
    &::-webkit-search-results-decoration {
      display: none;
    }
  }

  .ais-SearchBox-submit {
    color: white;
    position: relative;
    z-index: 2;
    cursor: pointer;
  }

  &__cta-search {
    color: #fff;
    position: relative;
    z-index: 2;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;

    .active & {
      @include breakpoint('lg') {
        color: #000;
      }
    }
  }

  .ais-reset-cta {
    position: absolute;
    top: 0;
  }

  &.active {
    .ais-search-input {
      width: 100%;
      pointer-events: auto;
      padding: 20px 40px;
      font-size: 2.1rem;

      @include breakpoint('lg') {
        width: 39.666666665vw;
      }
    }

    &__cta-search {
      color: #fff;
    }
  }

  .ais-Highlight-highlighted {
    background-color: $red;
    color: $white;
  }

  .ais-Pagination {
    .ais-Pagination-list {
      list-style: none;
    }

    .ais-Pagination-item {
      &--previousPage {
      }

      &--nextPage {
      }

      .ais-Pagination-item {
      }
    }
  }
}

.ais-search-results {
  background-color: $grey-b2b;
  padding: 4rem;
  max-height: calc(100vh - 100px);
  overflow: auto;
  position: absolute;
  top: calc(100% + 70px);
  left: 0;
  width: 100vw;

  @include breakpoint('lg') {
    right: 0;
    left: initial;
    top: 100%;
    max-width: 39.666666665vw;
  }

  &__item {
    margin-bottom: 3rem;

    em {
      font-size: 2.1rem;
      font-style: normal;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
